import Navbar from "../../NavBar/NavBar";
import Footer from "../../Home/Footer.js";
import Whatsapp from "../../Home/Whatsapp.js";
import Spinner from "../../../components/Home/Spinner.js";
import Project1 from "./section_page/Project1.js";
import { useEffect } from "react";

const EcoleOFPPTGuelmim = () => {

  useEffect(() => {
  document.title =
    "Gare Rabat Agdal – Solutions Lumineuses Architecturales | UNIK SYSTEM";

  let metaDescription = document.querySelector("meta[name='description']");
  if (!metaDescription) {
    metaDescription = document.createElement("meta");
    metaDescription.name = "description";
    document.head.appendChild(metaDescription);
  }
  metaDescription.setAttribute(
    "content",
    "Projet Gare Rabat Agdal : conception lumineuse innovante par UNIK SYSTEM alliant esthétique architecturale, mise en lumière des façades et solutions LED intérieures pour un confort visuel optimal."
  );

  let metaKeywords = document.querySelector("meta[name='keywords']");
  if (!metaKeywords) {
    metaKeywords = document.createElement("meta");
    metaKeywords.name = "keywords";
    document.head.appendChild(metaKeywords);
  }
  metaKeywords.setAttribute(
    "content",
    "gare rabat agdal éclairage, solutions lumineuses architecturales, éclairage façade gare, LED architecturale maroc, mise en lumière bâtiment, UNIK SYSTEM lighting"
  );
}, []);


  return (
    <div className="body">
      <Spinner />
      <Navbar />
      <Whatsapp />
      <Project1 />
      <Footer />
    </div>
  );
};

export default EcoleOFPPTGuelmim;
